import { useState } from "react";
import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { useDataProvider, useNotify } from "react-admin";

const SyncPullList = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const handlePullNow = async () => {
    setBusy(true);
    setResult(null);
    try {
      const response = await dataProvider.simplePostJson("sync/trigger", {
        data: { mode: "pull" },
      });
      setResult(response);
      notify(response?.message || "Pull manual dijalankan.", { type: "info" });
    } catch (error) {
      const message =
        error?.body?.message || error?.message || "Pull manual gagal dijalankan.";
      setResult({ status: "error", message });
      notify(message, { type: "warning" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 960, mx: "auto" }}>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack spacing={3}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <SyncAltIcon fontSize="small" />
            <Box>
              <Typography variant="h5">Sync Pull</Typography>
              <Typography variant="body2" color="text.secondary">
                Jalankan pull manual dari depo ke pusat saat koneksi kembali
                normal atau saat Anda ingin mengambil update sekarang.
              </Typography>
            </Box>
          </Stack>

          <Alert severity="info">
            Halaman ini untuk operasi pull saja. Tidak ada propagasi data di sini.
          </Alert>

          <Button
            variant="contained"
            onClick={handlePullNow}
            disabled={busy}
            sx={{ width: "fit-content" }}
          >
            {busy ? "Menjalankan..." : "Pull sekarang"}
          </Button>

          {result ? (
            <Alert severity={result.status === "error" ? "error" : "success"}>
              {result.message || "Pull manual berhasil dijalankan."}
            </Alert>
          ) : null}
        </Stack>
      </Paper>
    </Box>
  );
};

export default SyncPullList;
